module.exports = __webpack_public_path__ + "static/media/cheveuxnappy.15f828b4.png";